import React from 'react';
import { Line } from 'react-chartjs-2'; // Import Line for area charts
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement, // Needed for points on the line
  LineElement,  // Needed for lines
  Title,
  Tooltip,
  Legend,
  Filler,       // Crucial for area filling
} from 'chart.js';

// Register necessary Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler // Register the Filler plugin for area charts
);

function PipelineAreaChart({title, pipelinedata}) {

  // --- Data Transformation ---
  let labels = []; // Will store 'Sp1', 'Sp2', 'Sp3', 'Sp4'
  let datasets = []; // Will store datasets for each 'Vendedor'

  // --- Handle undefined, null, or empty pipelinedata ---
  if (!pipelinedata || pipelinedata.length === 0) {
    return (
      <div style={{ height: '120px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <p>Loading chart data...</p> {/* Or simply return null; */}
      </div>
    );
  }

  // Extract labels from the first salesperson's data
  if (pipelinedata.length > 0 && pipelinedata[0].values.length > 0) {
    labels = pipelinedata[0].values.map(item => Object.keys(item)[0]);
  }

  // Define a color palette for the vendors
  const vendorColors = [
    'rgba(54, 162, 235, 0.7)', // Blue
    'rgba(255, 99, 132, 0.7)', // Red
    'rgba(75, 192, 192, 0.7)', // Green
    'rgba(153, 102, 255, 0.7)',// Purple
    'rgba(255, 159, 64, 0.7)', // Orange
  ];
  const borderColors = [
    'rgba(54, 162, 235, 1)',
    'rgba(255, 99, 132, 1)',
    'rgba(75, 192, 192, 1)',
    'rgba(153, 102, 255, 1)',
    'rgba(255, 159, 64, 1)',
  ];


  // Create datasets for each vendor
  datasets = pipelinedata.map((vendorData, index) => {
    const dataValues = labels.map(label => {
      // Find the value for the current label (e.g., 'Sp1') for this vendor
      const spObject = vendorData.values.find(item => Object.keys(item)[0] === label);
      return spObject ? Object.values(spObject)[0] : 0; // Return value or 0 if not found
    });

    return {
      label: vendorData.owner_usr && vendorData.owner_usr.length > 6
              ? vendorData.owner_usr.slice(0, 6) + '.'
              : vendorData.owner_usr, // e.g., 'Vendedor 1'
      data: dataValues,
      fill: true, // This is crucial for filling the area below the line
      backgroundColor: vendorColors[index % vendorColors.length],
      borderColor: borderColors[index % borderColors.length],
      tension: 0.4, // Adds a slight curve to the lines
       // --- CAMBIOS PARA LOS PUNTOS SUTILES ---
      pointRadius: 2, // Tamaño del punto (ajusta a tu gusto)
      pointBackgroundColor: 'rgba(255, 255, 255, 0.8)', // Color de fondo del punto (blanco semi-transparente)
      pointBorderColor: borderColors[index % borderColors.length], // Color del borde del punto (mismo color de la línea)
      pointBorderWidth: 1, // Ancho del borde del punto
      pointHoverRadius: 5, // Tamaño del punto al pasar el mouse
      // --- FIN CAMBIOS PARA LOS PUNTOS SUTILES ---
    };
  });

  const chartData = {
    labels: labels,
    datasets: datasets,
  };
  // --- End Data Transformation ---

  const options = {
    responsive: true,
    maintainAspectRatio: false, // Allow chart to fill container
    plugins: {
      legend: {
        display: false, // Show legend to distinguish vendors
        position: 'top',
      },
      title: {
        display: true,
        text: title,
      },
      tooltip: {
        mode: 'index',
        intersect: false, // Show tooltip for all datasets at the hovered point
      },
       datalabels: { // <--- THIS IS THE CRUCIAL PART TO DISABLE VALUE LABELS
        display: false,
      },
    },
    scales: {
      x: {
        stacked: true, // Crucial for stacking areas
        grid: {
          display: false,
        },
        ticks: {
          display: true,
          maxRotation: 45,
          minRotation: 0,
          font: { size: 10 },
        },
      },
      y: {
        stacked: true, // Crucial for stacking areas
        beginAtZero: true,
         grid: {
          display: false, // Hide vertical grid lines
        },
        
        ticks: {
          display: false, // <-- **HERE: This hides the 'Sp1', 'Sp2', etc. labels**
        } // Start Y-axis from zero
      },
      
    },
  };

  return (
 <div style={{ height: '120px', width: '100%' }}>
      <Line data={chartData} options={options} />
    </div>
  );
}

export default PipelineAreaChart;